<template>
  <div>
    <h3>Fournisseurs- Manitoba</h3>
    <table class="table table-sm table-bordered">
      <thead>
        <tr>
          <th>ORS</th>
          <th>Fournisseur</th>
          <th>Statut du plan</th>
          <th style="text-align: center;">Exigences</th>
          <th style="text-align: center;">RH et Pts Serv.</th>
          <th style="text-align: center;">Total des RH</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='f in fss' :key='f.agency_name'>
          <td v-text="f.ors"></td>
          <td v-text="f.agency_name"></td>
          <td v-text="f.statut"></td>
          <td style="text-align: right;" v-text="remplis(f.req_filled, f.req_to_be_filled)"></td>
          <td style="text-align: right;" v-text="remplis(f.pts_service_with_hr, f.no_pts_service)"></td>
          <td style="text-align: right;" v-text="f.total_hr"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ListeRliss',
  props: {
    fss: Array
  },
  methods: {
    percent(a, b) {
      if(b==0) return "n/a";
      return (100*a/b).toFixed(1) + "%";
    },
    remplis(a, b) {
      return a.toString() + "/" + b.toString();
    }
  }
}
</script>
